module.exports = __webpack_public_path__ + "static/media/S (138).c8b0c8f1.jpg";